import {
  Button,
  TextField,
  Grid
} from "@mui/material";
import {useState} from "react";
import {API} from "../framework/api";
import { confirmAlert } from 'react-confirm-alert';
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

export function PasswordResetPage(props) {

  const [values, setValues] = useState({
    email: '',
  });

  const handleChange = (event, prop) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handlePwReset = () => {
    API.getAPI().user_reset_password(values.email).then(()=> {
      confirmAlert({
        title: "Återställning begärd",
        message: "Om din e-post finns registrerad hos oss skickas nu e-post med återställningsinstruktioner till dig.",
        buttons: [{
          label: "Ok",
          onClick: () => {}
        }]
      });
    }).catch((e) => {
      confirmAlert({
        title: "Begäran misslyckades",
        message: "Begäran om lösenordsåterställning misslyckades. Kontrollera dina uppgifter och försök igen.",
        buttons: [{
          label: "Avfärda",
          onClick: () => {}
        }]
      });
      console.error(e);
    });
  }

  return (
    <div>
      <div className={"App-title"}>Lösenordsåterställning</div>
      <div className={"App-container App-drop-shadow"}>
        <Grid container={true} spacing={2}>
          <Grid item xs={12} sm={12}>
            <div className={"App-fieldTitle"}>Ange din registrerade e-post.</div>
          </Grid>
          <Grid item xs={12} sm={12}>

            {/*** Email ***/}

            <TextField
              fullWidth={1}
              type="email"
              id="outlined-basic"
              label="E-post (frivilligt)"
              variant="outlined"
              value={values.email}
              onChange={(e)=> handleChange(e, 'email')}
            />
          </Grid>
          <Grid item xs={12} sm={12} className={"u-textRight u-marginT20"}>

            <Button
              className={"App-button-contained"}
              variant={"contained"}
              onClick={handlePwReset}
            >
              Återställ mitt lösenord
            </Button>
          </Grid>
        </Grid>

      </div>
      <div className={"App-footer"}>
        {/*** Hjälptext och länk till registrering ***/}

        Har du inget konto? Klicka <span className={"u-clickable u-bold"} onClick={() => { document.location.hash = "#/register"; }}>här för att registrera dig</span>.
      </div>
    </div>
  );
}
